import React from "react";
import Sidebar from "./Sidebar";

// One shared shell for every authenticated page, instead of each page
// hand-rolling its own background + sidebar offset. Sidebar is a normal
// (non-fixed) flex child sized to h-screen, and this content pane is the
// only thing that scrolls - that's what keeps the sidebar visually pinned
// without position:fixed or a manual ml-64 anywhere else.
const AdminLayout = ({ children }) => {
  return (
    <div className="flex h-screen bg-paper">
      <Sidebar />
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  );
};

export default AdminLayout;
